import { types } from "mobx-state-tree";

import { StorageModel } from "../../services/storage/StorageModel";
import { endpoints } from "../../services/api/ApiEndpoints";

const FileTypesModel = types.model({
  acceptedFileTypes: "",
});

export const FileTypesStorageModel = types
  .compose(FileTypesModel, StorageModel)
  .named("FileTypesStorageModel")
  .actions((self) => {
    return {
      mapResponse(configuredFileTypes: string) {
        self.acceptedFileTypes = configuredFileTypes;
      },
    };
  })
  .views((self) => ({
    get endpoint() {
      const endpoint = endpoints.get("accepted_file_types");
      return endpoint;
    },
    get isLoading() {
      return !self.acceptedFileTypes;
    },
  }));
